export const contactType = [
  { title: "Call me", value: "call_me" },
  { title: "Text me", value: "text_me" },
];

const CheckoutInformationTheme2 = () => {
  return null;
};
export default CheckoutInformationTheme2;
